// @ts-ignore
import { VueReCaptcha } from 'vue-recaptcha-v3'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const options = {
    siteKey:
      typeof config.public.recaptchaSiteKey === 'string'
        ? config.public.recaptchaSiteKey
        : '6Lcr2eEqAAAAAFELXFZCz3SzFnwSJGW7q_m-pIQG',
    loaderOptions: {
      useRecaptchaNet: true,
      autoHideBadge: true
    }
  }
  nuxtApp.vueApp.use(VueReCaptcha, options)
})
